import React, { createContext, useContext, useState } from 'react';
import { trackEvent } from '../Utils/analytics';

const ModalContext = createContext();

export const MODAL_TYPES = {
  INTRO: 'IntroModal',
  KILL: 'KillModal',
  PUNISHMENT: 'PunishmentModal',
  GAME_LOST: 'GameLostModal',
  CONGRATS: 'CongratsModal',
  ABOUT: 'AboutModal',
  WISDOM: 'WisdomModal',
  SOUND_SETTINGS: 'SoundSettings',
  // Add more as needed
};

const initialModalState = {
  type: MODAL_TYPES.INTRO,
  props: {},
  isOpen: true,
};

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState(initialModalState);
  const [lastSimulator, setLastSimulator] = useState(null);

  const openModal = (type, props = {}) => {
    // Validate modal type to prevent crashes - allow both enum values and legacy string types
    const validTypes = [...Object.values(MODAL_TYPES), 'SoundSettings'];
    if (!type || !validTypes.includes(type)) {
      if (process.env.NODE_ENV === 'development') {
        console.warn('Invalid modal type:', type);
      }
      return;
    }
    trackEvent('modal_open', { type });
    setModal({ type, props, isOpen: true });
  };
  
  const closeModal = () => setModal((m) => ({ ...m, isOpen: false }));

  // Reset to safe state if modal gets corrupted
  const resetModal = () => setModal(initialModalState);

  return (
    <ModalContext.Provider value={{ 
      modal, 
      openModal, 
      closeModal, 
      resetModal, 
      lastSimulator, 
      setLastSimulator 
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
